import React from 'react';
import {observer} from "mobx-react-lite";
import {roundToSigns} from "../utils/utils";
import {getColorClass} from "../utils/utils";

const Table = ({allInfo}) => {
    const subjects = Object.keys(allInfo[Object.keys(allInfo)[0]].currMarks);
    return (
        <div className="table-block">
            <div style={{fontFamily: "Source_Sans3_semibold, sans-serif", fontSize: "20px", textAlign: "center", marginBottom: "10px"}}>Таблица успеваемости</div>
            <div className="table">
                <table border={1}>
                    <tbody>
                    <tr>
                        <th>Предмет / Период</th>
                        {Object.keys(allInfo).map(key => <th style={{textAlign: "center"}} key={key}>{key}</th>)}
                    </tr>
                    {subjects.map((sub, index) => {
                        const rounds = [];
                        return (
                            <tr key={sub}>
                                <th>{sub}</th>
                                {Object.keys(allInfo).map(key => {
                                    if (key.toLowerCase() === "год") {
                                        let sum = 0;
                                        let len = 0;
                                        for (let r of rounds) {
                                            if (r !== 0) {
                                                sum += r;
                                                len += 1;
                                            }
                                        }
                                        const mean = roundToSigns(len !== 0 ? sum/len : "0.00")
                                        return <td key={key} className={getColorClass(mean)}>
                                            {mean !== "0.00" ? mean : "-"}
                                        </td>
                                    } else {
                                        const mean = allInfo[key].means[index].mean
                                        rounds.push(roundToSigns(Number(mean)))
                                        return (
                                            <td key={key} className={allInfo[key].means[index].colorClass}>
                                                {mean !== "0.00" ? mean : "-"}
                                            </td>
                                        )
                                    }
                                })}
                            </tr>
                        );
                    })}
                    <tr>
                        <th>Итого:</th>
                        {Object.keys(allInfo).map(key => {
                            if (key.toLowerCase() !== "год") {
                                const curr = allInfo[key].meanOfMeans.mean;
                                return <td key={key} className={allInfo[key].meanOfMeans.colorClass}>{curr !== "нет оценок" ? curr : "-"}</td>
                            }
                        })}
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default observer(Table);